import createPalette from '@mui/material/styles/createPalette';

export const VegaAtilierPalette = createPalette({
    common: {
        black: '#000',
        white: '#FFF',
    },
    primary: {
        light: '#E02D3F',
        main: '#CF323F',
        dark: '#902C2F',
        contrastText: '#FFF',
    },
    secondary: {
        light: '#DF5361',
        main: '#D62839',
        dark: '#AC202E',
        contrastText: '#FFF',
    },
    success: {
        light: '#A9DE54',
        main: '#8AC926',
        dark: '#76AB21',
        contrastText: '#23330A',
    },
    warning: {
        light: '#FBCF23',
        main: '#E3B505',
        dark: '#C8A108',
        contrastText: '#6B5500',
    },
    grey: {
        50: '#F3F4F6',
        100: '#E8E9ED',
        200: '#D2D5DD',
        300: '#D0D4DC',
        400: '#C5C9D3',
        500: '#B9BECA',
        600: '#AEB3C2',
        700: '#A2A8B9',
        800: '#969DB0',
        900: '#8B92A7',
        A100: '#7F879F',
        A200: '#737D96',
        A400: '#69728C',
        A700: '#606980',
    },
    text: {
        primary: '#02213B',
        secondary: '#69728C',
        disabled: '#D2D5DD',
    },
    divider: '#C5C9D3',
    action: {
        active: 'rgba(96, 105, 128, 0.54)',
        hover: 'rgba(96, 105, 128, 0.04)',
        hoverOpacity: 0.04,
        selected: 'rgba(96, 105, 128, 0.08)',
        selectedOpacity: 0.08,
        disabled: 'rgba(96, 105, 128, 0.26)',
        disabledBackground: 'rgba(96, 105, 128, 0.50)',
        disabledOpacity: 0.38,
        focus: 'rgba(96, 105, 128, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
    },
});
